import GlossaryForm from "./GlossaryForm";

export default GlossaryForm